export default {
    install(Vue) {
        Vue.prototype.$replaceSpecialChars = (value) => {
            if (!value) return ''
            value = value.replace('�', 'Ñ')
            return value;
        }
    }
}